var _style, _rect, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuctionSheetLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 200",
    style: {
      enableBackground: "new 0 0 600 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;fill:#DDDDDD;}\n\t.st1{fill:#023F87;}\n\t.st2{fill:#023F88;stroke:#023F88;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st3{fill:#39B54A;stroke:#39B54A;stroke-width:3.1539;stroke-miterlimit:10;}\n\t.st4{display:none;fill:#1E4384;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 600,
    height: 200
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_169_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_170_",
    className: "st1",
    d: "M117,110.3l8.6,64.7h-15.2l-0.9-11.5H104l-0.9,11.5H87.7l7.8-64.7H117z M109.2,151.7 c-0.9-7.2-1.4-16.4-2.3-27c-1.4,12.4-2.6,21.6-2.9,27C104,151.7,109.2,151.7,109.2,151.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_173_",
    className: "st1",
    d: "M162.1,110.3v43.1c0,4.9,0,8.3-0.3,10.3c-0.3,2-1.1,4-2.6,6c-1.4,2-3.2,3.7-5.5,4.9 c-2.3,1.1-4.9,1.7-8,1.7c-3.4,0-6.6-0.6-9.2-2c-2.6-1.1-4.6-2.9-6-4.9c-1.4-2-2-4.3-2.3-6.6c-0.3-2.3-0.3-7.2-0.3-14.4v-38.2h14.9 v48.6c0,2.9,0,4.6,0.3,5.5c0.3,0.9,0.9,1.1,1.7,1.1s1.4-0.6,1.7-1.4c0.3-0.9,0.3-2.9,0.3-6v-47.7H162.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_175_",
    className: "st1",
    d: "M202.9,138.5H188v-11.2c0-3.2-0.3-5.2-0.6-6s-1.1-1.1-2-1.1c-1.1,0-2,0.6-2.3,1.4 c-0.3,0.9-0.6,3.2-0.6,6.3v29.9c0,3.2,0.3,5.2,0.6,6c0.3,0.9,1.1,1.4,2.3,1.4c1.1,0,1.7-0.6,2.3-1.4c0.6-0.9,0.6-3.2,0.6-6.9v-8 h14.9v2.6c0,6.6-0.3,11.5-1.1,14.4c-0.9,2.9-2.6,5.2-5.5,7.5c-2.9,2-6.3,3.2-10.6,3.2s-8-0.9-10.9-2.6c-2.9-1.7-4.6-4.3-5.7-7.5 c-0.9-3.2-1.4-7.8-1.4-14.4v-19c0-4.6,0-8,0.3-10.3s1.1-4.6,2.6-6.6c1.4-2.3,3.4-3.7,5.7-5.2c2.6-1.1,5.5-1.7,8.6-1.7 c4.3,0,8,0.9,10.9,2.9c2.9,2,4.9,4.3,5.7,7.2c0.9,2.9,1.4,7.2,1.4,13.2v6H202.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_177_",
    className: "st1",
    d: "M238.5,110.3v12.9h-8.9V175h-14.9v-51.7h-8.9v-12.9H238.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_179_",
    className: "st1",
    d: "M256.9,110.3V175H242v-64.7H256.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_181_",
    className: "st1",
    d: "M297.2,148c0,6.6,0,11.2-0.3,13.8c-0.3,2.6-1.1,5.2-2.6,7.5c-1.4,2.3-3.4,4-5.7,5.2 c-2.3,1.1-5.2,1.7-8.6,1.7c-3.2,0-5.7-0.6-8.3-1.7c-2.6-1.1-4.3-2.9-6-5.2c-1.4-2.3-2.3-4.6-2.6-7.5c-0.3-2.3-0.6-7.2-0.6-13.8 v-10.9c0-6.6,0-11.2,0.3-13.8c0.3-2.6,1.1-5.2,2.6-7.5s3.4-4,5.7-5.2c2.3-1.1,5.2-1.7,8.6-1.7c3.2,0,5.7,0.6,8.3,1.7 c2.6,1.1,4.3,2.9,6,5.2s2.3,4.6,2.6,7.5c0.3,2.9,0.3,7.2,0.3,14.1V148H297.2z M282.2,126.7c0-2.9-0.3-4.9-0.6-5.7 c-0.3-0.9-0.9-1.1-1.7-1.1s-1.4,0.3-1.7,1.1c-0.3,0.6-0.6,2.6-0.6,6v30.2c0,3.7,0,6,0.3,6.9c0.3,0.9,0.9,1.4,2,1.4 c1.1,0,1.7-0.6,2-1.4c0.3-1.1,0.3-3.4,0.3-7.2V126.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_184_",
    className: "st1",
    d: "M336.2,110.3V175H323l-7.8-29.3V175h-12.6v-64.7h12.6l8.3,29v-29H336.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_186_",
    className: "st1",
    d: "M386.8,129.9H373V125c0-2.3-0.3-3.7-0.6-4.3c-0.3-0.6-0.9-0.9-1.7-0.9s-1.7,0.3-2,1.1 c-0.3,0.9-0.6,2-0.6,3.7c0,2.3,0.3,3.7,0.9,4.9c0.6,1.1,2,2.3,4.3,4c6.6,4.3,10.9,8,12.6,10.9c1.7,2.9,2.6,7.5,2.6,13.8 c0,4.6-0.6,8-1.4,10.1c-0.9,2.3-2.9,4-5.5,5.5c-2.9,1.4-6,2.3-9.5,2.3c-4,0-7.5-0.9-10.3-2.6c-2.9-1.7-4.6-3.7-5.5-6.6 c-0.9-2.6-1.4-6.3-1.4-11.2v-4.3h13.8v8c0,2.3,0.3,4,0.6,4.6s1.1,1.1,2,1.1c0.9,0,1.7-0.6,2.3-1.4s0.9-2.3,0.9-4 c0-3.7-0.6-6.3-1.4-7.5c-0.9-1.1-3.2-3.2-6.9-5.7c-3.7-2.9-6.3-4.9-7.5-6c-1.1-1.1-2.3-2.9-2.9-5.2c-0.9-2.3-1.1-5.2-1.1-8.3 c0-4.9,0.6-8.6,1.7-10.9c1.1-2.3,2.9-4,5.5-5.5c2.6-1.1,5.5-2,9.2-2c4,0,7.2,0.6,10.1,2c2.9,1.4,4.6,3.2,5.5,5.5 c0.9,2,1.4,5.7,1.4,10.9v2.9H386.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_188_",
    className: "st1",
    d: "M427,110.3V175h-14.9v-27h-4.6v27h-14.9v-64.7h14.9v23h4.6v-23H427z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_190_",
    className: "st1",
    d: "M433.1,110.3h25v12.9H448v12.4h9.5V148H448v14.1h10.9V175h-25.9V110.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_192_",
    className: "st1",
    d: "M463.2,110.3h25v12.9h-10.1v12.4h9.5V148h-9.5v14.1h10.9V175h-25.9V110.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_194_",
    className: "st1",
    d: "M522.7,110.3v12.9h-8.9V175h-14.9v-51.7H490v-12.9H522.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_328_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_345_",
    className: "st2",
    d: "M110.7,58.2l-6.9,42.2h-6.6l-6.9-42.2h5.5l4.6,32.2l4.6-32.2H110.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_343_",
    className: "st2",
    d: "M113.2,100.4V58.2h14.1v5.2h-8.6V76h7.5v5.2h-7.5v14.1h8.6v5.2H113.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_340_",
    className: "st2",
    d: "M131.3,58.2h11.2c4.3,0,6.6,2.3,6.6,7.2v10.3c0,3.7-1.1,6-3.4,6.9l4,17.5h-5.5l-3.7-17h-3.4 v17h-5.7V58.2z M136.8,78.6h3.7c1.7,0,2.6-1.1,2.6-3.2v-9.2c0-2-0.9-3.2-2.6-3.2h-3.7V78.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_338_",
    className: "st2",
    d: "M153.5,100.4V58.2h5.7v42.2H153.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_336_",
    className: "st2",
    d: "M177.6,76v5.2h-7.5v19.3h-5.7V58.2h14.1v5.2h-8.3V76H177.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_334_",
    className: "st2",
    d: "M182.2,100.4V58.2h5.7v42.2H182.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_332_",
    className: "st2",
    d: "M193.1,100.4V58.2h14.1v5.2h-8.3V76h7.5v5.2h-7.5v14.1h8.3v5.2H193.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_329_",
    className: "st2",
    d: "M211.2,100.4V58.2h9.8c5.2,0,8,2.6,8,8v28.2c0,4-2.3,6-6.9,6 C222.2,100.4,211.2,100.4,211.2,100.4z M217,95.3h4.3c1.4,0,2.3-0.6,2.3-2v-27c0-2-0.9-3.2-2.6-3.2h-4V95.3z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    className: "st3",
    d: "M25.6,48.1l17,22.7c0,0,55.7-58.5,75-64.5c0,0-40.5,26.9-73.6,89.5C44,95.8,29,60.8,25.6,48.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M585.9,54.6c0,0,0-6-0.8-8.5c-0.6-3.4-1.7-5.9-3.4-7.8c-2-2.2-4.5-3.7-7.2-4.6c-3-1.5-24.5-1.3-24.5-1.3 L99.5,31.5v8.9h450.6h14.6c3.5,0,6.9,1.5,9.2,4c2.2,2.4,3.3,5.5,3,8.7l-9.2,127.7c-0.5,6.1-5.9,10.8-12.2,10.8H57.6H42.9 c-3.5,0-6.9-1.5-9.2-4c-2.2-2.4-3.3-5.5-3-8.7l5.1-77.4h-9l-2.5,30.1c0,0-2.4,51.9-1.6,54.4c0.6,3.4,1.7,5.9,3.4,7.8 c2,2.2,4.5,3.7,7.2,4.6c3,1.5,24.5,1.3,24.5,1.3l497.8,1c11,0,20.3-8.4,21.2-19.1l6.7-97.1C583.4,84.4,586,57.3,585.9,54.6z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-93-118h-497c-18.7,0-34,15.3-34,34V202c0,18.7,15.3,34,34,34h497c18.7,0,34-15.3,34-34V-84 C-59-102.7-74.3-118-93-118z M-63.5,196.3c0,18.7-15.3,34-34,34h-487.9c-18.7,0-34-15.3-34-34V-78.3c0-18.7,15.3-34,34-34h487.9 c18.7,0,34,15.3,34,34V196.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuctionSheetLogo);
export default __webpack_public_path__ + "static/media/auction-sheet-logo.61eb70596f0567d3dd23183bcf3be4b3.svg";
export { ForwardRef as ReactComponent };